module.exports = __webpack_public_path__ + "media/images/icon-calendar-4a22e040236fe4a60c83367a4e7803d7.svg";